import { SKY_API_ENDPOINT } from './apiFetcher';
import type { ResponseError } from './apiFetcher';
import useApi from './hooks/useApi';

// The savings totals (sUSDS, DSR and their sum) and the utilization are read
// from sky-api (/internal/atlas/savings/). Rates, depositors and activity still
// come from atlas.
export function useSavings(
  daysAgo: string | number = 1
): [any | undefined, ResponseError | undefined] {
  const [response, error] = useApi({
    baseUrl: SKY_API_ENDPOINT,
    url: '/savings/',
    queryParams: {
      days_ago: daysAgo
    }
  });
  return [response?.data, error];
}

export function useSavingsHistoric(
  daysAgo: string | number
): [any[] | undefined, ResponseError | undefined] {
  const [response, error] = useApi({
    baseUrl: SKY_API_ENDPOINT,
    url: '/savings/historic/',
    queryParams: {
      days_ago: daysAgo
    }
  });
  return [response?.data, error];
}
